"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWsFormattedFuturesUserDataEvent = exports.isWsFormattedSpotUserDataEvent = exports.isWsFormattedUserDataEvent = exports.isWsFormatted24hrTicker = exports.isWsFormattedKline = exports.isWsFormattedMarkPriceUpdate = void 0;
/*
  Use type guards to narrow down types with minimal efforts.
*/
function isWsFormattedMarkPriceUpdate(data) {
    return Array.isArray(data)
        && data.length !== 0
        && data[0].eventType === 'markPriceUpdate';
}
exports.isWsFormattedMarkPriceUpdate = isWsFormattedMarkPriceUpdate;
function isWsFormattedKline(data) {
    return !Array.isArray(data) && data.eventType === 'kline';
}
exports.isWsFormattedKline = isWsFormattedKline;
function isWsFormatted24hrTicker(data) {
    return !Array.isArray(data) && data.eventType === '24hrTicker';
}
exports.isWsFormatted24hrTicker = isWsFormatted24hrTicker;
function isWsFormattedUserDataEvent(data) {
    return !Array.isArray(data) && data.wsKey.includes('userData');
}
exports.isWsFormattedUserDataEvent = isWsFormattedUserDataEvent;
function isWsFormattedSpotUserDataEvent(data) {
    return isWsFormattedUserDataEvent(data) && data.wsMarket.includes('spot');
}
exports.isWsFormattedSpotUserDataEvent = isWsFormattedSpotUserDataEvent;
function isWsFormattedFuturesUserDataEvent(data) {
    return isWsFormattedUserDataEvent(data) && data.wsMarket.includes('usdm');
}
exports.isWsFormattedFuturesUserDataEvent = isWsFormattedFuturesUserDataEvent;
//# sourceMappingURL=typeGuards.js.map